import { useState, useContext } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { AccessType } from '@atlassian/jira-project-access/types';
import { getStatusCodeGroup } from '@atlassian/jira-project-custom-roles/src/services/utils/index.tsx';
import MainProviderContext from '../access-page-context';
import type { Props } from './types';

export const getCurrentAccessFetchUrl = (baseUrl: string, projectId: number): string =>
	`${baseUrl}/rest/internal/simplified/1.0/accesslevel/project/${projectId}`;

const CurrentAccessService = (props: Props) => {
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<unknown>(null);
	const [data, setData] = useState<unknown>(null);
	const projectContext = useContext(MainProviderContext);
	const fetch = async (): Promise<AccessType | null> => {
		const { baseUrl, projectId, projectKey } = projectContext;
		setLoading(true);
		try {
			const response = await fetchJson(getCurrentAccessFetchUrl(baseUrl, projectId));
			setLoading(false);
			setData(response);
			return response;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (err: any) {
			setLoading(false);
			setData(null);
			setError(err);
			fireErrorAnalytics({
				meta: {
					id: 'getCurrentAccess',
					packageName: 'jiraUsersAndRoles',
					teamName: 'olympus',
				},
				error: err,
				attributes: {
					projectKey,
					statusCode: getStatusCodeGroup(err),
				},
				sendToPrivacyUnsafeSplunk: true,
			});
		}
		return null;
	};

	// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'FetchError | null'. | TS2322 - Type 'unknown' is not assignable to type 'AccessType | null'.
	return props ? props.children({ loading, error, data, fetch }) : null;
};

export default CurrentAccessService;
